import _ from 'lodash';
import store from '../../context/store/store';
import {voiceSDK} from 'ur-voice-sdk';
import { playAudio, storeMomData, storeTranscript } from './asrTTS';
import { noTranscript, toastInformation } from './common';
import { ASR_Languages, calldetail, closeCaptionmeetingState } from '../../models/callModel';
import { UserDetails } from '../../models/model';
import { contactService } from '../contactService';
let fullData: any = {};
let audioContext_Arr:any = {};
const bufferSize = 4096;
const numberOfInputChannels = 1;
const numberOfOutputChannels = 1;

const create_Audio_Buffer = (onAudioProcess: any, stream: any, guid: string) => {
  try {
    if (stream) {
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      const audioContext = new AudioContext();
      let audioStream = new MediaStream(stream.getAudioTracks());
      if (audioStream) {
        const source = audioContext.createMediaStreamSource(audioStream);
        const processor = audioContext.createScriptProcessor(
          bufferSize,
          numberOfInputChannels,
          numberOfOutputChannels
        );
        processor.onaudioprocess = onAudioProcess;
        source.connect(processor);
        processor.connect(audioContext.destination);
        audioContext_Arr[guid] =
          { mediaStream: audioStream, processor: processor, source: source, audioContext: audioContext };
      }
    }
  }
  catch (e: any) { console.log("error", e);}
};

export const initializeRecognition = (lang: string, guid: string) => {
  try {
    fullData[guid] = { voiceSDKService: '', AudioCaptureService: '' };
    fullData[guid].voiceSDKService = new voiceSDK.RealtimeAPIService();
    fullData[guid].AudioCaptureService = voiceSDK.AudioCaptureService;
    console.log('Inititalize Recognition....',lang);
    fullData[guid].AudioCaptureService.initialize();

    fullData[guid].voiceSDKService.connect().then(async() => {
      fullData[guid].voiceSDKService.startRecognition(lang,fullData[guid].AudioCaptureService.getSampleRate())
        .then(async(value: any) => {
          console.log("value is",value);
        });
      let sockEvent = fullData[guid].voiceSDKService.getEventEmitter();
      noTranscript();
      addEventListener_Asr(lang, sockEvent, guid);
    });
  }
  catch (e: any) { console.log("error", e);}
};

const addEventListener_Asr = (lang: String, sockEvent: any, guid: string) => {
  try {
    let loggedUserDetails:UserDetails = store.getState().loginReducer.userdetails || [];
    let videoRenderList = store.getState().updatedCallList.callDetails || [];
    let videoData: calldetail = _.find(videoRenderList, { guid: guid.substring(0, guid.length - 4) });
    sockEvent.on('voice_message_transcript', (data: any) => {
      switch (data.message) {

      case "RecognitionStarted":
        if (videoData && (videoData.remoteStream || videoData.localstream)) {
          var stream = (guid.includes('_rem'))
            ? videoData.remoteStream.clone() : videoData.localstream.clone();

          create_Audio_Buffer((audioProcessingEvent: any) => {
        //fullData[guid].AudioCaptureService.start((audioProcessingEvent: any) => {
            let videoRenderList = store.getState().updatedCallList.callDetails || [];
            let videoData: calldetail = _.find(videoRenderList, { guid: guid.substring(0, guid.length - 4) });
            if (guid.includes('_rem')) {
              fullData[guid].voiceSDKService.sendAudioBuffer(audioProcessingEvent.inputBuffer.getChannelData(0));
            }
            else {
              if (videoData && !videoData.muteState) {
                fullData[guid].voiceSDKService.sendAudioBuffer(audioProcessingEvent.inputBuffer.getChannelData(0));
              }
            }
          }, stream,guid);
        }
        else { toastInformation("Recognition could not be started. ","failure"); }
        break;
      case "AddPartialTranscript":
        console.log("received data", data.metadata.transcript);
        break;
      case "DataAdded":
        if (data.seq_no === fullData[guid].voiceSDKService.seqNoIn) {
          fullData[guid].voiceSDKService.seqNoIn++;
        } else {
          console.log('Unexpected sequence number from API');
        }
        break;
      case "Error":
        console.log("Recognition could not be started");
        toastInformation('Recognition could not be started. '+ data?.reason,"failure");
        break;
      case "Warning":
        console.log("Warning Data--->", data);
        break;
      case "AddTranscript":
          console.log("received data", data.metadata.transcript);
        let text = data.metadata.transcript;
  
        let speakerName: string = (guid.includes('_loc')) ?
          loggedUserDetails.caller_id : videoData.contact.caller_id || "Unknown Caller";
        
        if (data.metadata.transcript !== "") {
          let closeCaption = store.getState().closeCaption || [];
          let transcripts = {
            lang: lang,
            speakerName: speakerName,
            text: text,
            convertedText: "",
            covertedlang: "",
            guid:new Date().getTime()
          };
          storeTranscript(transcripts);
          let { updatedLanguages, keywords } = closeCaption;
          if (updatedLanguages.transcription_code !== 'en') {
            let trans: any = {
              transcripts:JSON.stringify(closeCaption.transcripts),
              targetLang:updatedLanguages.transcription_code
            };
            contactService.getlanTranslation(trans);
          }
        //MOM store
        //const { keywords } = closeCaption;
          keywords.some(function(item:any){
            if (text.toLowerCase().includes(item.toLowerCase())) {
              let mom = {
                lang: lang,
                speakerName: speakerName,
                text: text
              };
              storeMomData(mom);
              return true;
            }
          });

        //audio speach
          let ASR_Data: any = store.getState().ASR_Language || [];
          if (guid.includes('_rem') &&  ASR_Data.asr_speaker_lan !== 'en') {
            let textToAudio = {
              source_lang: ASR_Data.asr_mic_lan,
              target_lang: ASR_Data.asr_speaker_lan,
              speakerName: speakerName,
              text: data.metadata.transcript
            };
            playAudio(textToAudio);
          }
        }
        break;
      case "EndOfTranscript":
        console.log("asr_stoped****");
        let closeCaption: closeCaptionmeetingState = store.getState().closeCaption || [];
        if (guid.includes('_rem') && closeCaption.remoteStreaming === 'need_to_start') {
          let asr_lan:ASR_Languages =store.getState().ASR_Language || [];
          initializeRecognition(asr_lan.asr_mic_lan, guid);
        }
        else if (guid.includes('_loc') && closeCaption.localStreaming === 'need_to_start') {
          let asr_lan:ASR_Languages =store.getState().ASR_Language || [];
          initializeRecognition(asr_lan.asr_mic_lan, guid);
        }
      }
    });
  }
  catch (e: any) { console.log("error", e);}
};

export const stopRecognition = (guid: string) => {
  try {
    if (
      audioContext_Arr[guid].mediaStream !== undefined &&
      audioContext_Arr[guid].processor !== undefined &&
      audioContext_Arr[guid].source !== undefined
    ) {
      audioContext_Arr[guid].processor.disconnect();
      audioContext_Arr[guid].source.disconnect();
      audioContext_Arr[guid].mediaStream = undefined;
      audioContext_Arr[guid].processor = undefined;
      audioContext_Arr[guid].source = undefined;
    }
    fullData[guid].voiceSDKService.stopRecognition();
  }
  catch (e: any) {
    console.log("voiceservice stop",e);
  }
};




